import {InputTextV2} from '@prtimes-basis/input';
import {FormField, useFormField} from '../../../form-field';
import styles from './department-field.module.css';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function DepartmentField() {
  return (
    <FormField.Root name='contactPersonInfo.department'>
      <Body />
      <FormField.Error />
      <span className={styles.overseasNote}>
        FOR OVERSEAS CUSTOMERS：Please use English or alphabetical notation
      </span>
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField();

  return (
    <InputTextV2
      type='text'
      wrapperClassName={companyRegistrationPageStyles.sizedInput}
      {...fieldProps}
    />
  );
}
